<template>
    <button-game name="logar com o google" typeLogin="social" social="google" action="google"></button-game>
</template>
<script>
import ButtonGame from './ButtonGame'
import Bus from '@/main.js'
import firebase from "firebase";
export default {
    components: {
        ButtonGame
    },
    created(){
        Bus.$on('google', this.authGoogle)
    },
    methods: {
        authGoogle(){
            var provider = new firebase.auth.GoogleAuthProvider();
            let self = this
            firebase.auth().languageCode = 'pt';
            firebase.auth().signInWithPopup(provider).then(function(result) {
                // This gives you a Google Access Token. You can use it to access the Google API.
                var token = result.credential.accessToken;
                self.$router.push('/middleware-game')
                // The signed-in user info.
                var user = result.user;
                // ...
                }).catch(function(error) {
                    alert(error.message)
                // Handle Errors here.
                var errorCode = error.code;
                var errorMessage = error.message;
                // The email of the user's account used.
                var email = error.email;
                // The firebase.auth.AuthCredential type that was used.
                var credential = error.credential;
                
                // ...
            });
        }
    }
}
</script>